import Layout from '~/components/Layout';
import LoginLink from '~/components/Links/LoginLink';
import RegisterForm from '~/components/LoginRegister/RegisterForm';

const RegisterPage = () => (
  <Layout title="Login" className="max-w-sm">
    <h2 className="mb-2 text-center md:mt-4">Join SidelineSwap</h2>
    <div className="mb-3 text-center">
      Save up to 70% on new and used gear,
      <br />
      or start selling yours today.
    </div>

    <RegisterForm
      authButtons
      postContent={
        <div className="mt-4 text-center">
          Already have an account?{' '}
          <LoginLink className="text-primary-500">Sign In</LoginLink>
        </div>
      }
    />
  </Layout>
);

export default RegisterPage;
